export interface IExposedInstanceLanguage {
  active: boolean;
  code: string;
  id: number;
  name: string;
}

export interface ILanguageCreationDetails {
  code: string;
  name: string;
}

export interface ILanguageModificationDetails {
  code: string;
  name: string;
}

export enum I18nTarget {
  EPICARE_DASHBOARD = "epicare-dashboard",
}

export interface II18nTranslation {
  lang: string;
  target: I18nTarget;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  i18n: any;
}
